import React from 'react';
import { motion } from 'framer-motion';
import 'bootstrap/dist/css/bootstrap.min.css';
import process from '../../../assets/MarysvillePage/Marysville_Ohio_Roofing_Contractor_Near_You.jpg';

const RoofingProcess = () => {
  const steps = [
    {
      id: "01",
      title: "Free Inspection",
      text: "Get a free roof inspection to uncover damage and receive professional recommendations right away."
    },
    {
      id: "02",
      title: "Estimate",
      text: "We provide a comprehensive roofing estimate with clear, upfront, and transparent pricing options."
    },
    {
      id: "03",
      title: "Material Selection",
      text: "We assist you in selecting durable, high-quality roofing materials that provide long-lasting protection for your property."
    },
    {
      id: "04",
      title: "Installation",
      text: "We install high-quality roofing systems with careful attention to detail and a strong focus on lasting craftsmanship."
    },
    {
      id: "05",
      title: "Final Inspection",
      text: "We complete a final quality check to make sure your roof meets our standards and that you are fully satisfied."
    }
  ];

  const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 }
    }
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 }
    }
  };

  return (
    <section className="cs-section replacement-process" style={{ backgroundColor: '#f8f9fa' }}>
      <div className="container">
        <div className="row align-items-stretch">

          {/* LEFT SIDE */}
          <motion.div
            className="col-lg-6 d-flex flex-column"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
          >
            {/* Title একদম উপরে */}
            <h2 className="cs-title cs-title-to-content roofing-header text-lg-start text-md-center">
              Our Roofing Replacement Process
            </h2>

            {/* Image বাকি সব জায়গা নেবে */}
            <motion.div
              className="roofing-image-wrapper flex-grow-1"
              whileHover={{ scale: 1.02 }}
              transition={{ duration: 0.4 }}
              style={{ minHeight: '420px' }}
            >
              <img
                src={process}
                alt="Roofing Process"
                className="roofing-image"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  display: 'block'
                }}
              />
            </motion.div>
          </motion.div>

          {/* RIGHT SIDE */}
          {/* offset-lg-1 removed and col-lg-5 changed to col-lg-6 to eliminate the gap */}
          <div className="col-lg-6 mt-5 mt-lg-0 d-flex align-items-center">
            <motion.div
              className="position-relative w-100"
              variants={staggerContainer}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-100px" }}
            >
              {/* Vertical Line */}
              <motion.div
                className="roofing-line"
                initial={{ height: 0 }}
                whileInView={{ height: '95%' }}
                transition={{ duration: 1.5, ease: "easeInOut" }}
              />

              {steps.map((step, index) => (
                <motion.div
                  key={index}
                  className="d-flex mb-4 position-relative roofing-step"
                  variants={fadeInUp}
                  whileHover={{ scale: 1.05 }}
                  transition={{
                    type: "spring",
                    stiffness: 300,
                    damping: 15
                  }}
                >
                  {/* Step Circle */}
                  <motion.div
                    className="roofing-step-circle"
                    whileHover={{
                      scale: 1.2,
                      rotate: 10,
                      boxShadow: "0 0 15px #3D3B6D"
                    }}
                    transition={{ duration: 0.4 }}
                  >
                    {step.id}
                  </motion.div>

                  {/* Step Text */}
                  <motion.div
                    whileHover={{ color: "#3D3B6D" }}
                    transition={{ duration: 0.3 }}
                  >
                    <h3 className="roofing-step-title">{step.title}</h3>
                    <p className="service-p">{step.text}</p>
                  </motion.div>
                </motion.div>
              ))}
            </motion.div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default RoofingProcess;